import { useAppSelector } from 'dux/app/hooks';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';
import { mediaMinWidth } from '@prose-ui/utils/media';

import ProductCTA from 'Containers/ProductCTA';

import { getCategoryByProductSlug } from 'dux/products/selectors';

const FixedButton = styled.div<{ shouldShow: boolean }>`
  position: fixed;
  z-index: 100;
  bottom: ${({ shouldShow }) => (shouldShow ? 0 : -85)}px;
  left: 0;

  display: flex;
  justify-content: center;

  width: 100%;
  padding: ${theme.spacing['8x']};

  transition: bottom 500ms;

  ${mediaMinWidth('sm')} {
    justify-content: flex-end;
    padding: 0 ${theme.spacing['12x']} ${theme.spacing['8x']} 0;
  }
`;

const StyledProductCTAButton = styled(ProductCTA)`
  width: 274px;
  border-radius: 2rem;
  box-shadow: 0 4px 4px 0 rgb(0 0 0 / 25%);
`;

type StickyConsultationCTAProps = {
  customOnClick?: null | ((arg0: string) => void);
  shouldShow: boolean;
  productSlug?: string;
  dataFrom?: string;
};

export const StickyProductCTA = ({
  shouldShow,
  customOnClick = null,
  dataFrom,
  productSlug,
}: StickyConsultationCTAProps) => {
  const productCategory = useAppSelector((state) =>
    getCategoryByProductSlug(state, { productSlug }),
  );
  return (
    <FixedButton shouldShow={shouldShow}>
      <StyledProductCTAButton
        customOnClick={customOnClick}
        dataFrom={dataFrom}
        noMargin
        productCategory={productCategory}
        slug={productSlug}
        variant="sorbetGreenOnHover"
      />
    </FixedButton>
  );
};
